import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	@import url(${vars.fontHeadlineUrl});

	position: relative;
	width: 100%;

	.hero-wrapper {
		min-height: 20em;
		.hero-image {
			margin: 4em 0 0 0;
			z-index: 1;
			min-height: 20em;
			height: 100%;
			width: 100%;
			object-fit: cover;
		}

		.hero-header {
			position: absolute;
			z-index: 2;
			top: 5em;
			left: 50%;
			transform: translateX(-50%);

			.header-title {
				font-family: ${vars.fontHeadline};
				display: inline-block;
				padding: 1em;
				width: max-content;
				background-image: url('/images/company-sites/underline.svg');
				background-size: 100%;
				background-position: center;
				background-repeat: no-repeat;
			}
		}
	}
	.search-wrapper {
		height: 10em;

		.search-box {
			max-width: 1366px;
			margin: 0 auto;
			padding: 3em 2.2em;
			background-color: ${vars.colorBlack};
			display: flex;
			flex-flow: column wrap;
			border-radius: 0.2em 0.2em 0 0;
			transform: translateY(-4em);

			.search-title {
				color: ${vars.colorTextWhite};
				font-size: 1em;
				margin: 0 0 1em 0;
			}

			.search-fields {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				gap: 1em;

				.name-search {
					max-width: 45%;

					.label-wrapper {
						.label-body {
							.layout-forms-input-label {
								color: ${vars.colorTextWhite};
							}
						}
					}
				}

				.industry-button {
					margin: 0.5em 0 0 0;
					width: 30%;

					.button {
						width: 100%;
						border: 0.08em solid ${vars.colorTextWhite};
						padding: 0.9em 1em;
						display: flex;
						justify-content: space-between;

						.button-content {
							color: ${vars.colorTextWhite};
							font-size: 1em;
						}
						.button-icon-after {
							filter: brightness(0) invert(1);
						}
						.button-icon-after-hover {
							display: none;
						}
					}

					&.cliked {
						.button {
							background-color: ${vars.colorElement};
							border: ${vars.colorElement};

							.button-content {
								color: ${vars.colorBlack};
							}
							.button-icon-after {
								filter: unset;
							}
						}
					}
				}

				.submit-button {
					margin: 0.5em 0 0 0;
					width: 25%;
					.button {
						width: 100%;
					}
				}
			}
		}
	}

	@media all and (max-width: ${vars.tabletL}) {
		.hero-wrapper {
			height: 14em;

			.hero-image {
				margin: 5em 0 0 0;
			}

			.hero-header {
				position: absolute;
				z-index: 2;
				top: 7em;
				left: 50%;
				transform: translateX(-50%);

				.header-title {
					font-family: ${vars.fontHeadline};
					display: inline-block;
					padding: 1em;
					background-image: url('/images/company-sites/underline.svg');
					background-size: 100%;
					background-position: center;
					background-repeat: no-repeat;
				}
			}
		}
		.search-wrapper {
			height: max-content;

			.search-box {
				transform: unset;
				border-radius: 0;
				.search-fields {
					flex-flow: column wrap;

					.name-search,
					.industry-button,
					.submit-button {
						min-width: 100%;
					}

					.name-search {
						font-size: 1.2em;
					}

					.industry-button,
					.submit-button {
						.button {
							font-size: 1.1em;
						}
					}
				}
			}
		}
	}

	@media all and (max-width: ${vars.mobileM}) {
		.hero-wrapper {
			.hero-header {
				top: 14em;
				.header-title {
					font-size: 1.7em;
				}
			}
		}
	}
`;
